import { get } from 'axios'

const endpoint = '/auth'

export const getPasswordRules = ({ token, action }) =>
  get(`${endpoint}/password-rules/${token}?action=${action}`)

export const getSecretQuestions = () => get(`${endpoint}/secret-questions`)

export const fetchPersonSecret = async () => get(`${endpoint}/person-secret`)

export default {
  getPasswordRules,
  getSecretQuestions,
}
